/* ==========================================================
   JCI Slider - Slick Infinite Override
   Makes existing Slick slider loop infinitely
   Does NOT modify layout or styles
   ========================================================== */

(function ($) {
  "use strict";

  function enableInfinite(section) {
    var $slideshow = $(section).find('.slick-slider');

    if (!$slideshow.length) return;

    // Only run if slick already initialized
    if ($slideshow.hasClass('slick-initialized')) {

      var slickInstance = $slideshow.slick('getSlick');

      // Force main infinite option
      if (!slickInstance.options.infinite) {
        $slideshow.slick('slickSetOption', 'infinite', true, false);
      }

      // Force infinite inside responsive breakpoints (mobile fix)
      if (slickInstance.options.responsive && slickInstance.options.responsive.length) {
        slickInstance.options.responsive.forEach(function (bp) {
          if (bp.settings) {
            bp.settings.infinite = true;
          }
        });
      }

      // Refresh WITHOUT touching layout settings
      $slideshow.slick('refresh');
    }
  }

  /* Init on page load */
  $(document).ready(function () {
    $('.product_image_text_slider_block').each(function () {
      enableInfinite(this);
    });
  });

  /* Shopify editor support */
  document.addEventListener('shopify:section:load', function (e) {
    var section = document.getElementById('section-id-' + e.detail.sectionId);
    if (section && section.classList.contains('product_image_text_slider_block')) {
      enableInfinite(section);
    }
  });

})(jQuery);